export default {
  setBanners: (state, banners = []) => {
    state.banners = banners;
  },
  setCacheMeta: (state, cacheMeta = {}) => {
    state.cacheMeta = {
      ...state.cacheMeta,
      ...cacheMeta
    };
  }
};
